import React from 'react';
import { FormSection, autofill } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { TextField, BoxDouble, RadioField, Section } from 'jbc-front/components/Form';
import { DeleteSquare } from 'jbc-front/components/icons';
import ActionButton from 'jbc-front/components/ActionButton';
import { bankThaiEng, maxLength9, maxLength20, isNumber } from 'src/utils/CustomValidators';
import { CLIENT_FORM } from 'src/constants/FormNames';
import BankSearchModalWrapper from 'src/components/BankSearchModalWrapper';
import styles from './BankItemSection.scss';

class BankItemSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchBankModalOpen: false,
      selectedBank: undefined
    };
  }

  render() {
    const { showModal, isModalOpen: isOpen, hideModal } = this.props;
    const { formKey, depositTypes, index, remove, removable, dispatch } = this.props;

    return (
      <div>
        <Section
          title={`${this.props.t('features.Employees.components.BankItemSection.bank_account_information')} ${index + 1}`}
          icon={
            removable ? (
              <div className={styles.delete}>
                <DeleteSquare onClick={remove} />
              </div>
            ) : (
              <div className={styles.nodelete}>
                <DeleteSquare />
                <div className={styles.nodeleteText}>{this.props.t('features.Clients.components.BankItemSection.Cannot_delete_because_it_has_been_set_up_in_the_employee_information')}</div>
              </div>
            )
          }
        >
          <FormSection name={formKey}>
            <ActionButton onClick={showModal} className="u-mb20">
              {this.props.t('features.Employees.components.BankItemSection.serch_bank_code')}
            </ActionButton>

            <BankSearchModalWrapper
              isOpen={isOpen}
              hideModal={hideModal}
              onSelect={(bank, branch) => {
                this.setState({
                  isSearchBankModalOpen: false
                });
                dispatch(autofill(CLIENT_FORM, `${formKey}.bankCode`, bank.bankCode));
                dispatch(autofill(CLIENT_FORM, `${formKey}.bankName`, bank.name));
                dispatch(autofill(CLIENT_FORM, `${formKey}.bankShortName`, bank.shortName));
                dispatch(autofill(CLIENT_FORM, `${formKey}.branchCode`, branch.branchCode));
                dispatch(autofill(CLIENT_FORM, `${formKey}.branchName`, branch.name));
                dispatch(autofill(CLIENT_FORM, `${formKey}.bankId`, bank.id));
                dispatch(autofill(CLIENT_FORM, `${formKey}.bankBranchId`, branch.id));
              }}
            />

            <BoxDouble>
              <TextField
                label={this.props.t('features.Employees.components.BankItemSection.bank_code')}
                name="bankCode"
                validate={[isNumber, maxLength9]}
                maxLength="9"
              />
              <TextField label={this.props.t('features.Employees.components.BankItemSection.bank_short_name')} name="bankShortName" maxLength="256" />
            </BoxDouble>
            <TextField label={this.props.t('features.Employees.components.BankItemSection.bank_name')} name="bankName" maxLength="256" />
            <BoxDouble>
              <TextField
                label={this.props.t('features.Employees.components.BankItemSection.branch_code')}
                name="branchCode"
                validate={[isNumber, maxLength9]}
                maxLength="9"
              />
              <TextField label={this.props.t('features.Employees.components.BankItemSection.branch_name')} name="branchName" maxLength="256" />
            </BoxDouble>

            <RadioField label={this.props.t('features.Employees.components.BankItemSection.account_type')} name="depositType" options={depositTypes} />

            <BoxDouble>
              <TextField
                label={this.props.t('features.EmployeeBonus.ShowBonusFbDataPage.bank_account_number')}
                type="text"
                name="accountNumber"
                validate={[isNumber, maxLength20]}
                maxLength="20"
              />
              <TextField
                label={this.props.t('features.Employees.components.BankItemSection.account_holder_name')}
                type="text"
                name="accountHolder"
                validate={[bankThaiEng]}
              />
            </BoxDouble>
          </FormSection>
        </Section>
      </div>
    );
  }
}

export default withTranslation('translation')(BankItemSection);
